import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./service.css";
import "../Styles/Payment.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import { IconDetalis } from "../../common/IconDetalis";
import { LeftRightlayout } from "../Container/LeftRightlayout";
import Form from "../Components/Form";
import { Input } from "../Components/Input";
import { Icon } from "../../common/CSS";
import { Header } from "../Container/Header";
import FormContextApi from "../../ContextApi";
import { getAllCities, getCityFromPincode } from "../../actions/user";
import { getProjectsListName } from "../../actions/projects";
import { sendToastMessage } from "../../actions/toast";
import { addAmountToWallet, getWalletDetails } from "../../actions/wallet";
import moment from "moment";
import {
  createIndependentTickets,
  getTicketsList,
} from "../../actions/tickets";
import Loader from "../../common/Loder";
import MapWithPlaces from "../Components/reactMap";
import config from "../../config";
import { gtag } from 'ga-gtag';
let autoComplete;

let timer;
const formName = 'serviceFrom';
export default function Service() {
    
    const { setwalletValue } = useContext(FormContextApi);
    const { ticketTableLoading } = useSelector((store) => store.loadingreducer);
    const { user, wallet_applicable } = useSelector((store) => store.userreducer);
    const { tickets } = useSelector((store) => store.ticketsreducer);
    const { projectlist } = useSelector((store) => store.projectsreducer);
    const [defaultProjectId, setdefaultProjectId] = useState(null);

    const dispatch = useDispatch();
    const [place_i, setplace_id] = useState({ onOff: false, placeId: '' });
    const [location, setlocation] = useState({
        lat: 22.878597243716452,
        lng: 79.63845536688986,
        pincode: '',
        address: '',
    });

    useEffect(() => {
        document.title = 'Services';
    }, []);

    useEffect(() => {
        if (tickets === undefined && user?.customer_id > 0) {
            dispatch(
                getTicketsList({
                    customerId: user?.customer_id,
                    count: true,
                    activeTab: 'alltickets',
                })
            );
        }
    }, [dispatch, tickets, user?.customer_id]);

    useEffect(() => {
        if (user?.customer_id > 0) {
            dispatch(getProjectsListName(user?.customer_id, false));
            dispatch(getWalletDetails({ updateBalance: true }));
        }
    }, [dispatch, user?.customer_id]);

    useEffect(() => {
        if (projectlist?.length === 1) {
            setwalletValue((prev) => {
                return projectlist[0]?.project?.customer_base_price;
            });
            setdefaultProjectId(projectlist[0].project.id);
        } else {
            let userCustomerCompanyName = user?.customer_company_name?.split(' ') || [];
            if (userCustomerCompanyName?.length < 1) {
                userCustomerCompanyName = user?.customer_company_name;
            } else {
                userCustomerCompanyName = userCustomerCompanyName[0];
            }
            if (userCustomerCompanyName?.length > 0) {
                projectlist?.filter((e) => {
                    const Pname = e.text.split('_');
                    if (Pname[0] === userCustomerCompanyName && Pname[1] === 'Field' && Pname[2] === 'Support' && e.project.service_type_id === 5) {
                        setwalletValue((prev) => {
                            return e?.project?.customer_base_price;
                        });
                        setdefaultProjectId(e.project.id);
                        return e;
                    }
                    return false;
                });
            }
        }
    }, [projectlist, user]);

    const memoRenderName = useCallback(() => {
        return (
            <MapWithPlaces
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${config.googleMapApiKey}&v=3.exp&libraries=geometry,drawing,places&callback=Function.prototype`}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                location={location}
                setlocation={setlocation}
            />
        );
    }, [location]);

    const Content = () => {
        return (
            <>
                <Header showButton path='/' />
                <div className='h-auto'>
                    <div className=''>
                        <div className={`${Icon.HeadingIcon} ${wallet_applicable && 'grid-cols-3'}`}>
                            <IconDetalis coloreIcon='text-darkblue' IconName='manage_accounts' IconHeading='Your Details' />
                            <IconDetalis coloreIcon='text-darkblue' IconName='devices' IconHeading='Select Service' />
                            {!wallet_applicable && <IconDetalis coloreIcon='text-stardust' IconName='currency_rupee' IconHeading='Payment' />}
                            <IconDetalis coloreIcon='text-stardust' IconName='engineering' IconHeading='Get Engineer' />
                            <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBox'>
                                <CheckCircleIcon />
                            </div>
                            <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBoxPanding'>
                                <PendingIcon />
                            </div>
                            {!wallet_applicable && <div className='w-110F rounded-none bg-stardust h-3P mt-3'></div>}
                            <div className='w-full rounded-none bg-stardust h-3P mt-3'></div>
                        </div>
                    </div>
                    <div className='mapContainer'>{memoRenderName()}</div>
                    {ticketTableLoading || wallet_applicable === undefined ? (
                        <div className='mt-24'>
                            <Loader speed='1' thickness='6' size='70' />
                        </div>
                    ) : (
                        <div className='w-11/12 p-2 m-auto pt-0  overflow-auto formContainer' style={{ height: '83vh' }}>
                            <ServiceFrom
                                tickets={tickets}
                                place_i={place_i}
                                setplace_id={setplace_id}
                                setlocation={setlocation}
                                location={location}
                                defaultProjectId={defaultProjectId}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    };

    const Imgsection = () => {
        return <div className='m-auto'></div>;
    };

    return <LeftRightlayout Content={Content} RightImg={Imgsection} />;
}

const ServiceFrom = ({
  tickets,
  setplace_id,
  place_i,
  location,
  setlocation,
  defaultProjectId,
}) => {
  const {
    serviceInit,
    setserviceInit,
    setTicketData,
    walletValue,
    access,
    setaccess,
  } = useContext(FormContextApi);
  const [form, setForm] = useState(serviceInit);
  const [options, setOption] = useState([]);
  const [formSubmit, setFormSubmit] = useState(true);
  const { cities, pinCity, user, wallet_applicable } = useSelector(
    (store) => store.userreducer
  );
  const { wallet } = useSelector((store) => store.walletreducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const citiesOptions = () => {
    let citesValue = cities?.map((e) => {
      return {
        value: e.value,
        label: e.text,
      };
    });
    return citesValue;
  };

  useEffect(() => {
    dispatch(getAllCities());
  }, [dispatch]);

  const getAddress = (latitude, longitude) => {
    var geocoder = new window.google.maps.Geocoder();
    var latlng = new window.google.maps.LatLng(latitude, longitude);
    if (latitude !== "" && geocoder && latlng) {
      geocoder.geocode(
        {
          latLng: latlng,
        },
        function (res, status) {
          if (res) {
            let add = res[1]?.address_components;
            let pin = add[add.length - 1].long_name;
            var forcity = res[0].formatted_address;
            var value = forcity.split(",");
            let count = value.length;
            let city = value[count - 3];
            let location_data = res[1]?.formatted_address;
            setForm({ ...form, address: location_data });
            setlocation({
              lat: latitude,
              lng: longitude,
              pincode: pin,
              address: location_data,
              city: city,
            });
          }
        }
      );
    }
  };

  const onSucessLocation = (location) => {
    getAddress(location.coords.latitude, location.coords.longitude);
  };

  const geolocationOptions = {
    enableHighAccuracy: true,
    maximumAge: 10000,
    timeout: 1000,
  };

  const errorCallback = (error) => {
    if (error.code === 1) {
      alert("Plases allow the location ");
    }
    console.log(error);
  };

  const getLotion = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        onSucessLocation,
        errorCallback,
        geolocationOptions
      );
    }
  };

  const displaySuggestions = (predictions, status) => {
    if (status === "OK") {
      let options = predictions.map((e) => {
        return { value: e.description, label: e.place_id };
      });
      setOption(options);
    } else {
      setOption([]);
    }
  };

  const geecodingAD = useCallback(() => {
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      {
        placeId: place_i?.placeId,
      },
      function (responses, status) {
        if (status === "OK") {
          var lat = responses[0].geometry.location.lat();
          var lng = responses[0].geometry.location.lng();
          geocoder.geocode(
            {
              latLng: responses[0].geometry.location,
            },
            function (res) {
              if (res) {
                let add = res[1]?.address_components;
                var forcity = res[0].formatted_address;
                var value = forcity.split(",");
                let count = value.length;
                let city = value[count - 3];
                let pin = add[add.length - 1].long_name;
                setlocation({
                  lat: lat,
                  lng: lng,
                  pincode: pin,
                  address: form.address,
                  city: city,
                });
              }
            }
          );
        }
      }
    );
  }, [form.address, place_i?.placeId, setlocation]);

  const getLotionByPincode = (pincode) => {
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: pincode }, function (results, status) {
      let latitude = results[0].geometry?.location?.lat();
      let longitude = results[0].geometry?.location?.lng();
      var forcity = results[0].formatted_address;
      var value = forcity.split(",");
      let count = value.length;
      let city = value[count - 3];
      let location_data = results[0].formatted_address;
      setlocation({
        lat: latitude,
        lng: longitude,
        pincode: "",
        address: location_data,
      });
      if (
        city !== location.city &&
        location?.city &&
        location?.city !== undefined
      ) {
        dispatch(
          sendToastMessage({
            message: "Your pincode not match your address",
            status: "danger",
          })
        );
        setFormSubmit(false);
      } else {
        setFormSubmit(true);
      }
    });
  };

  useLayoutEffect(() => {
    if (pinCity) {
      let pincodecity = citiesOptions()?.filter((e) => {
        if (e.value === pinCity?.fk_city_id) {
          return e;
        }
        return false;
      });
      if (pincodecity !== undefined) {
        setForm((prev) => {
          return { ...prev, city: pincodecity[0] };
        });
      }
    }
  }, []);

  useEffect(() => {
    if (location?.city?.length !== 0 && formSubmit === false) {
      setFormSubmit(true);
    }
    if (location?.pincode?.length === 6) {
      let pincode = location?.pincode;
      setForm((prve) => {
        return { ...prve, pincode: pincode, address: location?.address };
      });
    }
  }, [location, formSubmit]);

  useEffect(() => {
    if (place_i?.placeId?.length > 0) {
      geecodingAD();
    }
  }, [place_i?.placeId, geecodingAD]);

  const handleScriptLoad = (value) => {
    if (value.length > 0) {
      autoComplete = new window.google.maps.places.AutocompleteService();
      const request = {
        input: value,
        componentRestrictions: { country: "In" },
      };
      autoComplete.getQueryPredictions(request, displaySuggestions);
    }
  };
  const debounce = (value) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      handleScriptLoad(value);
    }, 1000);
  };

  useEffect(() => {
    let value = form?.address;
    if (value?.length > 0 && place_i.onOff) {
      debounce(value);
    }
  }, [form?.address]);

  useEffect(() => {
    if (form?.pincode.length === 6) {
      let pincode = form?.pincode;
      dispatch(getCityFromPincode(pincode));
    }
    if (form?.pincode?.length === 6 && form?.pincode !== location?.pincode) {
      getLotionByPincode(form?.pincode);
    }
  }, [dispatch, form?.pincode]);

  const submit = (form) => {
    if (formSubmit) {
      if (defaultProjectId === undefined || defaultProjectId === null) {
        dispatch(
          sendToastMessage({ message: "Project not found", status: "danger" })
        );
      } else {
        const formattedDate = moment(form?.date).format("YYYY-MM-DD HH:MM:SS");
        const data = {
          location_data: [
            {
              hard_copy_required: 0,
              self_pickup_required: 1,
              description: form?.describe,
              is_boq_required: 1,
              is_noc_required: 1,
              job_fk_pincode_id: form?.pincode,
              job_site_address_1: form?.address,
              job_site_contact_name:
                user?.last_name === "" || user?.last_name === undefined
                  ? user?.first_name
                  : `${user?.first_name} ${user?.last_name}` ||
                    user?.first_name,
              job_site_contact_mobile: user?.mobile,
              job_site_contact_mail: user?.email,
              execution_date: formattedDate,
              service_type_id: form?.service_type?.value,
              ticket_type: 0,
              userId: user?.id,
              use_case_id: 1,
              site_type: 1,
              fk_sign_off_template_id: 1,
              fk_project_id: defaultProjectId,
              job_shipping_fk_pincode_id: form?.pincode,
              job_pickup_fk_pincode_id: form?.pincode,
              job_shipping_address_1: form?.address,
              job_pickup_address_1: form?.address,
              fk_noc_template_id: 1,
              external_site_id: "sole1234",
              site_branch_name: "test",
              region: "region",
              zone: "zone",
              ticket_source: "WEBSITE",
              platform: "horizon",
              fk_customer_id: user?.customer_id,
              end_user_id: 1,
              requester_email: user?.email,
            },
          ],
        };
        setTicketData({ ticketdata: data, file: form?.document });
        if (wallet_applicable) {
            dispatch(
                createIndependentTickets({
                    data,
                    existing: true,
                    addNew: false,
                    refresh: false,
                    type: 2,
                    formName: formName,
                    navigate,
                    file: form?.document,
                    setgtag: () => {
                        gtag('event', 'Click', {
                            IndependentTickets: 'button',
                        });
                    },
                })
            );
        } else {
          setaccess({ pageacces: false, paymentacces: true, gstModal: true });
          if (wallet?.wallet_amount < walletValue) {
            if (
              user?.customer_gst_number?.length === 0 &&
              access?.gstModal !== "stop"
            ) {
              navigate("/payment");
            } else {
              setaccess({
                pageacces: false,
                paymentacces: true,
                gstModal: "stop",
              });
              dispatch(
                addAmountToWallet({
                  orderAmount: walletValue,
                  navigate: navigate,
                  formName: formName,
                })
              );
            }
          } else {
            if (
              user?.customer_gst_number?.length === 0 &&
              access?.gstModal !== "stop"
            ) {
              navigate("/payment");
            } else {
              setaccess({
                pageacces: false,
                paymentacces: true,
                gstModal: "stop",
              });
              navigate("/payment");
            }
          }
        }

        setserviceInit(form);
      }
    } else {
      dispatch(
        sendToastMessage({
          message: "Your pincode not match your address",
          status: "danger",
        })
      );
    }
  };

  return (
    <>
      <Form
        initialValues={serviceInit}
        btnText={
          tickets?.length === 0
            ? "Proceed To Payment"
            : wallet_applicable
            ? { title: "Get Engeriner", show: true }
            : { title: "Proceed To Payment", show: true }
        }
        setForm={setForm}
        form={form}
        formName={formName}
        submit={(e) => submit(e)}
      >
        <Input
          place_i={place_i}
          setplace_id={setplace_id}
          type="googlesearch"
          options={options}
          name="address"
          label="Service Address"
          required={true}
          placeholder="Write Address"
          setlocation={setlocation}
          setFormSubmit={setFormSubmit}
        />
        <p className="text-right text-1rem flex justify-end items-center mt-2 mb-0 text-scogoOrange">
          <span
            className=" cursor-pointer"
            onClick={() => {
              getLotion();
            }}
          >
            <span className="material-icons text-1rem mr-1 ">my_location</span>
            Use Current Location
          </span>
        </p>
        <Input
          type="number"
          name="pincode"
          label="Service pincode"
          required={true}
        />
        <Input
          type="textarea"
          name="describe"
          inputcln="pb-0 h-20 "
          label="Service Description"
          required={true}
          placeholder="Write Description"
        />
        <Input
          type="datepicker"
          name="date"
          label="Service Date"
          placeholder="Choose date"
        />
        <Input
          type="upload"
          name="document"
          label="Additional Documents"
          placeholder="Choose File"
          multiple
        />
        <h1 className="text-17F text-center mb-4 mt-4">
          Service Fee:{" "}
          <span className="text-scogoprimary"> ₹ {walletValue} </span>{" "}
        </h1>
      </Form>
    </>
  );
};
